<template>
	<div>
		<!-- 雷达图示例 -->
		<radar-chart :chart-data="radarData" :indicator="radarIndicator" title="能力评估雷达图" height="300px" />

		<!-- 半圆进度图 -->
		<div style="width: 300px; margin: 20px auto;">
			<progress-chart :value="80" title="较高" sub-title="证件数量超过80%同类人" color="#ff6a3d" height="200px" width="100%" />
		</div>

		<!-- 分布折线图 -->
		<div style="margin: 20px auto; padding: 20px; background-color: #fff; border-radius: 8px;">
			<distribution-line-chart
				:chart-data="[30, 45, 5, 15, 5]"
				:x-axis-data="['1级', '2级', '3级', '4级', '5级']"
				:your-position="1"
				line-color="#1890ff"
				area-color="rgba(24, 144, 255, 0.1)"
				marker-color="#1890ff"
				width="300px"
				height="300px"
			/>
		</div>

		<!-- 饼图 -->
		<div style="margin: 20px auto; padding: 20px; background-color: #fff; border-radius: 8px;">
			<h3 style="text-align: center; margin-bottom: 20px;">人员类型分布</h3>
			<pie-chart
				:chart-data="personnelTypeData"
				title="人员结构分析"
				:show-legend="true"
				legend-position="right"
				height="400px"
				width="600px"
			/>
		</div>

		<!-- 半环形图 -->
		<div style="margin: 20px auto; padding: 20px; background-color: #fff; border-radius: 8px;">
			<donut-chart
				:chart-data="qualificationTypeData"
				title="资质类型分析"
				:center-text="20"
				center-sub-text="本"
				:show-legend="true"
				legend-position="right"
				height="300px"
				width="600px"
			/>
		</div>

		<div style="margin: 20px auto; padding: 20px; background-color: #fff; border-radius: 8px;">
			<behavior-bar-chart
				:good-behavior-data="goodBehaviorData"
				:bad-behavior-data="badBehaviorData"
				:blacklist-data="blacklistData"
				:month-data="monthData"
				default-period="year"
				height="400px"
				@period-change="handlePeriodChange"
			/>
		</div>

		<div style="margin: 20px auto; padding: 20px; background-color: #fff; border-radius: 8px;">
			<person-behavior-bar-chart
				:good-behavior-data="goodBehaviorData"
				:bad-behavior-data="badBehaviorData"
				:blacklist-data="blacklistData"
				:month-data="monthData"
				height="800px"
			/>
		</div>

		<!-- 稳定性分析折线图 -->
		<div style="margin: 20px auto; padding: 20px; background-color: #fff; border-radius: 8px;">
			<person-stability-line-chart
				title="稳定性分析"
				:chart-data="stabilityData"
				:x-axis-data="stabilityMonthData"
				y-axis-label="数量"
				line-color="#1890ff"
				height="400px"
				default-period="year"
				@period-change="handleStabilityPeriodChange"
			/>
		</div>
	</div>
</template>

<script>
	import RadarChart from '@/components/Chart/RadarChart.vue'
	import ProgressChart from '@/components/Chart/ProgressChart.vue'
	import DistributionLineChart from '@/components/Chart/DistributionLineChart.vue'
	import PieChart from '@/components/Chart/PieChart.vue'
	import DonutChart from '@/components/Chart/DonutChart.vue'
	import BehaviorBarChart from '@/components/Chart/BehaviorBarChart.vue'
	import PersonStabilityLineChart from '@/components/Chart/PersonStabilityLineChart.vue'
	import PersonBehaviorBarChart from '@/components/Chart/PersonBehaviorBarChart.vue'

	// echarts示例
	export default {
		name: 'ChartDemo',
		components: {
			RadarChart,
			ProgressChart,
			DistributionLineChart,
			PieChart,
			DonutChart,
			BehaviorBarChart,
			PersonStabilityLineChart,
			PersonBehaviorBarChart
		},
		props: {},
		data() {
			return {
				// 雷达图数据
				radarIndicator: [
					{ name: '技术', max: 100 },
					{ name: '沟通', max: 100 },
					{ name: '团队协作', max: 100 },
					{ name: '执行力', max: 100 },
					{ name: '创新', max: 100 }
				],
				radarData: [
					{
						value: [80, 90, 70, 85, 65],
						name: '个人能力'
					}
				],
				// 人员类型饼图数据
				personnelTypeData: [
					{ value: 25, name: '一级注册建造师' },
					{ value: 18, name: '二级注册建造师' },
					{ value: 12, name: '一级临时建造师' },
					{ value: 9, name: '二级临时建造师' },
					{ value: 22, name: '一级造价工程师' },
					{ value: 17, name: '二级造价工程师' },
					{ value: 14, name: '土建施工员' },
					{ value: 21, name: '装饰装修施工员' },
					{ value: 16, name: '设备安装施工员' },
					{ value: 19, name: '市政工程施工员' },
					{ value: 13, name: '土建质量员' },
					{ value: 23, name: '装饰装修质量员' },
					{ value: 11, name: '设备安装质量员' },
					{ value: 8, name: '市政工程质量员' },
					{ value: 26, name: '材料员' },
					{ value: 15, name: '机械员' },
					{ value: 20, name: '劳务员' },
					{ value: 7, name: '资料员' }
				],
				// 半环形图数据
				qualificationTypeData: [
					{ value: 8, name: '资质类型1' },
					{ value: 5, name: '资质类型2' },
					{ value: 3, name: '资质类型3' },
					{ value: 2, name: '资质类型4' },
					{ value: 2, name: '资质类型5' }
				],

				// 行为统计数据
				goodBehaviorData: [2, 4, 0, 2, 6, 2],
				badBehaviorData: [0, 2, 4, 2, 4, 2],
				blacklistData: [0, 1, 0, 0, 1, 0],
				monthData: ['1月', '2月', '3月', '4月', '5月', '6月'],

				// 稳定性分析数据
				stabilityData: [1, 1, 2, 2, 2, 2],
				stabilityMonthData: ['1月', '2月', '3月', '4月', '5月', '6月']
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {
			// 处理周期变更
			handlePeriodChange(period) {
				// 根据选择的周期更新数据
				// 这里模拟不同周期的数据
				if (period === 'month') {
					// 近一月数据
					this.goodBehaviorData = [0, 0, 0, 0, 0, 2]
					this.badBehaviorData = [0, 0, 0, 0, 0, 1]
					this.blacklistData = [0, 0, 0, 0, 0, 0]
					this.monthData = ['1日', '6日', '11日', '16日', '21日', '26日']
				} else if (period === 'quarter') {
					// 近一季度数据
					this.goodBehaviorData = [0, 0, 0, 2, 6, 2]
					this.badBehaviorData = [0, 0, 0, 2, 4, 2]
					this.blacklistData = [0, 0, 0, 0, 0, 0]
					this.monthData = ['1月', '2月', '3月', '4月', '5月', '6月']
				} else if (period === 'halfYear') {
					// 近半年数据
					this.goodBehaviorData = [0, 0, 2, 4, 2, 6]
					this.badBehaviorData = [0, 0, 3, 2, 1, 4]
					this.blacklistData = [0, 0, 0, 0, 0, 0]
					this.monthData = ['1月', '2月', '3月', '4月', '5月', '6月']
				} else {
					// 近一年数据
					this.goodBehaviorData = [2, 4, 0, 2, 6, 2, 3, 1, 4, 5, 2, 3]
					this.badBehaviorData = [0, 2, 4, 2, 4, 2, 1, 3, 2, 1, 3, 2]
					this.blacklistData = [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0]
					this.monthData = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
				}
			},

			// 处理稳定性分析周期变更
			handleStabilityPeriodChange(period) {
				// 根据选择的周期更新数据
				if (period === 'month') {
					// 近一月数据
					this.stabilityData = [2, 2, 2, 2, 2, 2]
					this.stabilityMonthData = ['1日', '6日', '11日', '16日', '21日', '26日']
				} else if (period === 'quarter') {
					// 近一季度数据
					this.stabilityData = [1, 2, 2, 2, 2, 2]
					this.stabilityMonthData = ['1月', '2月', '3月', '4月', '5月', '6月']
				} else if (period === 'halfYear') {
					// 近半年数据
					this.stabilityData = [1, 1, 2, 2, 2, 2]
					this.stabilityMonthData = ['1月', '2月', '3月', '4月', '5月', '6月']
				} else {
					// 近一年数据
					this.stabilityData = [1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2]
					this.stabilityMonthData = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
				}
			}
		}
	}
</script>

<style lang="scss" scoped></style>
